import { take, fork, cancel, put, call, delay, select } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import v from "../../validators/GlobalValidator";
import { callApi } from "./callApi";
import {changePasswordSuccess, changePasswordFailure, successGlobalAccount,
  sendVerificationCodeSuccess, sendVerificationCodeFailure, refreshAccountBalanceSuccess} from "../actionCreators/account"; //refreshAccountDataSuccess,
import {showNotification} from "../actionCreators/notification";
import { getGlobalAccount } from '../selectors';
import config from "../../config/config";
import {getGlogalAccountData} from "./helpers/club";
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

function* refreshAccountsData ({ currAccs, currClb }) {
}

function* refreshAccountBalance({ accountData }) {
    try {
        const response = yield call(callApi, `${config.API_URL}/club/refreshAccounts`, 'POST', accountData);
        yield put(refreshAccountBalanceSuccess(response.data.result.authenticationData[0].wallets));
    } catch (e) {}
}

function* updateGlobalAccount () {
    try {
        const { username, clubId: skinId, token } = yield select(getGlobalAccount);

        const response = yield call(callApi, `${config.API_URL}/club/authenticate`, 'POST', { username, skinId, token });
        yield put(successGlobalAccount(getGlogalAccountData(response.data.result.authenticationData)));
    } catch (e) {}
}

function* changePassword ({ password, newPassword, repeatPassword }) {
    try {
        const {username, clubId: skinId, id: accountId, token} = yield select(getGlobalAccount);
        let validation = v.validateChangePassword({currentPassword: password, newPassword, repeatPassword});
        if (!validation.success) {
            yield put(changePasswordFailure({changePasswordFail:validation.error}));
            return;
        }
        const changedPasswordData = yield call(callApi, `${config.API_URL}/club/account/${accountId}/password`, 'PATCH', {username, password, newPassword, skinId, token});
        const { message } = changedPasswordData.data.result;
        if (message) {
            yield put(changePasswordSuccess(message));
            yield browserHistory.goBack();
            yield put(showNotification({message: message}));
        }
    } catch (e) {
        yield put(changePasswordFailure({changePasswordFail: {currentPassword: e.response.data.err.message}}));
    }
}

function* verifyEmail ({ email }) {
    try {
      const {email, token} = yield select(getGlobalAccount);
      // const linkEmailResponse = yield call(callApi, `${config.API_URL}/club/account/${accountId}/linkEmail`, 'POST', {email, token});
      let linkEmailResponse = Math.floor(1000000 + Math.random() * 9000000);
      yield put(sendVerificationCodeSuccess({verificationCode: linkEmailResponse}));
    } catch (e) {
      yield put(sendVerificationCodeFailure(e));
    }
}

export function* watchLogin() {
    while (true) {
        const action = yield take(actionTypes.REFRESH_ACCOUNTS_DATA_REQUEST);
        yield fork(refreshAccountsData, action.value);
    }
}

export function* watchChangePassword() {
    while (true) {
        const action = yield take(actionTypes.CHANGE_PASSWORD_REQUEST);
        yield fork(changePassword, action.value);
    }
}

export function* watchLinkEmail() {
    while (true) {
        const action = yield take(actionTypes.LINK_EMAIL_VERIFICATION_REQUEST);
        yield fork(verifyEmail, action.value);
    }
}

export function* watchGlobalAccount() {
    while (true) {
        yield take([actionTypes.EXCHANGE_SAPPHIRES_SUCCESS, actionTypes.DAILY_BONUS_SUCCESS]);
        yield fork(updateGlobalAccount);
    }
}

export function* watchRefreshAccountBalance() {
    while (true) {
        const action = yield take(actionTypes.REFRESH_ACCOUNT_BALANCE_REQUEST);
        yield fork(refreshAccountBalance, action);
    }
}